import {UUID} from '../../../shared/types/uuid.type';
import {createAction, props} from '@ngrx/store';
import {DvrRecord} from '../../../services/api/dvr/dvr.model';

export const stopRecord = createAction(
  '[StopRecord] Stop Record',
  props<{ recordId: UUID }>()
);

export const stopRecordSuccess = createAction(
  '[StopRecord] Stop Record Success',
  props<{ data: DvrRecord }>()
);

export const stopRecordFailure = createAction(
  '[StopRecord] Stop Record Failure',
  props<{ error: unknown }>()
);

export const clearStopRecordState = createAction(
  '[Records] clear Stop Record State'
);
